import React from "react";
import "./AgentTabs.scss";
import AgentAccountTabs from "../AgentAccountTabs/AgentAccountTabs";

function AgentTabs({ selectedUser, selectedUserData, setSelectedUserData }) {
  return (
    <div className="account-tabs-container">
      <AgentAccountTabs
        selectedUser={selectedUser}
        selectedUserData={selectedUserData}
        setSelectedUserData={setSelectedUserData}
      />
    </div>
  );
}

export default AgentTabs;
